<script>
export function useFifaGisDirectionOptions() {
  const trafficModelOptions = [
    { label: 'Best guess (default)', value: 'best_guess' },
    { label: 'Minimum', value: 'min' },
    { label: 'Maximum', value: 'max' },
    { label: 'Average', value: 'avg' },
  ]

  const trafficModelsMap = trafficModelOptions.reduce(
    (result, next) => ({ ...result, [next.value]: next.label }),
    {},
  )

  return {
    trafficModelOptions,
    trafficModelsMap,
  }
}

export default {
  name: 'FifaGisDirectionsConfigSubform',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: Object, default: () => ({}) },
    validators: { type: Object },
    serverErrors: { type: Object },
  },
  setup() {
    const { trafficModelOptions } = useFifaGisDirectionOptions()
    return {
      trafficModelOptions,
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', { ...this.modelValue, ...value })
    },
  },
}
</script>

<template lang="pug">
.form-label.google-range-preference FIFA GIS engine options:
  .row.mt-2
    .col-md-6.col-sm-12
      ea-select(
        :additional-errors="serverErrors?.trafficModel"
        :modelValue="modelValue?.trafficModel"
        :options="trafficModelOptions"
        :reduce="item => item.value"
        :validators="validators?.trafficModel"
        @update:modelValue="val => updateValue({ trafficModel: val })"
        label="Traffic model:"
        name="durationRule.trafficModel"
        placeholder="Best guess (default)"
      )

    .col-md-6.col-sm-12.pt-4.mt-2
      ea-switch(
        :additional-errors="serverErrors?.useRmm"
        :modelValue="modelValue?.useRmm"
        :validators="validators?.useRmm"
        @update:modelValue="val => updateValue({ useRmm: val })"
        label="Use RMM"
        name="fifaGis.rmmEnabled"
      )
</template>

<style scoped lang="scss"></style>
